import React from 'react';
import ReportingClassesSalesPage from '../components/ReportingClassesSalesPage';

const ReportingClassesSalesApp = (props) => (
  <ReportingClassesSalesPage {...props} />
);

export default ReportingClassesSalesApp;
